export const PAYMENT_METHODS = {
    AMAZON_V2: 'amazon_v2',
    APPLEPAY_V2: 'stripe_apple_pay',
    CASH_ON_DELIVERY: 'cashondelivery',
    CHECKMO: 'checkmo',
    FREE: 'free',
    GIFT: 'ugiftcert',
    GOOGLE_PAY: 'stripe_google_pay',
    KLARNA: 'klarna',
    PAYMENT_OS: 'ms_paymentsos',
    PAYPAL: 'paypal_express',
    PAYPAL_V3: 'paypal_v3',
    PRIMER: 'primer_cc',
    PRIMER_APPLE_PAY: 'primer_apple_pay',
    PRIMER_GOOGLE_PAY: 'primer_google_pay',
    PRIMER_KLARNA: 'primer_klarna',
    PRIMER_PAYPAL: 'primer_paypal',
    PRIMER_VENMO: 'primer_venmo',
    RECURLY: 'recurly',
    RECURLY_PAYPAL: 'recurly_paypal',
    STRIPE: 'stripe',
    VENMO: 'braintree_venmo',
};

export const PAYMENT_CODE_MESSAGE: {[key: string]: string} = {
    [PAYMENT_METHODS.AMAZON_V2]: 'Amazon pay',
    [PAYMENT_METHODS.APPLEPAY_V2]: 'Apple pay',
    [PAYMENT_METHODS.CASH_ON_DELIVERY]: 'Cash On Delivery',
    [PAYMENT_METHODS.CHECKMO]: 'Checkmo',
    [PAYMENT_METHODS.FREE]: 'Free',
    [PAYMENT_METHODS.GIFT]: 'Gift certificate',
    [PAYMENT_METHODS.GOOGLE_PAY]: 'Google Pay',
    [PAYMENT_METHODS.KLARNA]: 'Klarna',
    [PAYMENT_METHODS.PAYMENT_OS]: 'Credit Card',
    [PAYMENT_METHODS.PAYPAL_V3]: 'PayPal',
    [PAYMENT_METHODS.PRIMER]: 'Credit Card',
    [PAYMENT_METHODS.PRIMER_APPLE_PAY]: 'Primer Apple Pay',
    [PAYMENT_METHODS.PRIMER_GOOGLE_PAY]: 'Primer Google Pay',
    [PAYMENT_METHODS.PRIMER_KLARNA]: 'Primer Klarna',
    [PAYMENT_METHODS.PRIMER_PAYPAL]: 'Primer Paypal',
    [PAYMENT_METHODS.RECURLY]: 'Recurly (Credit Card)',
    [PAYMENT_METHODS.RECURLY_PAYPAL]: 'Recurly (PayPal)',
    [PAYMENT_METHODS.STRIPE]: 'Stripe',
    [PAYMENT_METHODS.VENMO]: 'Venmo',
    paypal_express: 'PayPal',
};

export const PAYMENT_METHODS_INSTANT = [
    PAYMENT_METHODS.APPLEPAY_V2,
    PAYMENT_METHODS.GOOGLE_PAY,
    PAYMENT_METHODS.AMAZON_V2,
    PAYMENT_METHODS.KLARNA,
    PAYMENT_METHODS.PRIMER_APPLE_PAY,
    PAYMENT_METHODS.PRIMER_GOOGLE_PAY,
    PAYMENT_METHODS.PRIMER_KLARNA,
    PAYMENT_METHODS.PRIMER_PAYPAL,
    PAYMENT_METHODS.PAYPAL_V3,
];

export const CREDIT_CARD_PAYMENT_METHODS = [
    PAYMENT_METHODS.STRIPE,
    PAYMENT_METHODS.PAYMENT_OS,
    PAYMENT_METHODS.PRIMER,
];

export const STANDARD_PAYMENT_METHODS = [
    PAYMENT_METHODS.CASH_ON_DELIVERY,
    PAYMENT_METHODS.CHECKMO,
    PAYMENT_METHODS.GIFT,
    PAYMENT_METHODS.FREE,
];

export const PAYMENT_METHODS_EXPRESS = [
    PAYMENT_METHODS.APPLEPAY_V2,
    PAYMENT_METHODS.GOOGLE_PAY,
    PAYMENT_METHODS.AMAZON_V2,
    PAYMENT_METHODS.PAYPAL_V3,
];

export const PRIMER_PAYMENT_METHODS = [
    PAYMENT_METHODS.PRIMER,
    PAYMENT_METHODS.PRIMER_APPLE_PAY,
    PAYMENT_METHODS.PRIMER_GOOGLE_PAY,
    PAYMENT_METHODS.PRIMER_KLARNA,
    PAYMENT_METHODS.PRIMER_PAYPAL,
    PAYMENT_METHODS.PRIMER_VENMO,
];
